import React from 'react';
import {Divider, Grid, Icon} from "semantic-ui-react";
import {FormattedHTMLMessage as MSGS} from "react-intl";
import {AccountItem} from "../view/CommonPage";

interface IProperties {
    creditorAccount: AccountItem,
    debtorAccount?: AccountItem;
}

export default class CardFromToAccount extends React.Component<IProperties> {
    render()
    {
        let from = new Array<JSX.Element>();
        if (this.props.debtorAccount)
        {
            from.push(
                <Divider vertical key={0}><Icon name='arrow right' /></Divider>,
                <Grid.Column key={1}>
                    {<MSGS id="welcome_page_payment_consent_from"/>}
                    <div className={"app-subtext"}>{this.props.debtorAccount.name}</div>
                    <div className={"app-subtext"}>{this.props.debtorAccount.code}</div>
                </Grid.Column>
            );
        }

        return (
            <div>
                <Grid columns={2} stackable textAlign='center'>
                    <Grid.Row verticalAlign='middle'>
                        {from}
                        <Grid.Column>
                            {<MSGS id="welcome_page_payment_consent_to"/>}
                            <div className={"app-subtext"}>{this.props.creditorAccount.name}</div>
                            <div className={"app-subtext"}>{this.props.creditorAccount.code}</div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }
}